import React from 'react'
import StaffsBox from './StaffsBox'
import { StaffTypeWrapper } from './styles'

export const SharesStaffs = () => {
  return (
    <StaffTypeWrapper>
      <StaffsBox type={'shareholder'} />
    </StaffTypeWrapper>
  )
}
